
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginSliceValue } from "../../redux/reducers/loginSlice";
  const useToggleStatus = () => {
    const { userDetails } = useSelector(loginSliceValue);
  const toggleTemplateStatus = async ({
    templateId,
    status,
  }: {
    templateId: string;
    status: string;
  }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/rtm/template/status?_id=${templateId}`,
        { status }, 
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + userDetails.token,
              },
        }
      );


    if (response?.status === 200) {
      toast.success(response.data.msg);
      return response;
    }

   
    } catch (error) {
        toast.error('Something went wrong while updating status');
   
    }
  };

  return { toggleTemplateStatus };
};

export default useToggleStatus 
